import logo from "./logo.svg";
import Mainmenu from "./components/Mainmenu";
import Topbar from "./components/Topbar";
import { NavLink, Route, Routes } from "react-router-dom";
import Useradd from "./pages/Useradd";
import Usersearch from "./pages/Usersearch";
import Login from "./Login";
import "./css/Toggleswitch.css";
import useUser from "./hooks/useUser";
import Surveyadd from "./pages/Surveyadd";
import Surveysearch from "./pages/Surveysearch";
import SurveyAnalyze from "./pages/SurveyAnalyze";
import Test from "./pages/Test";
import SurveySetup from "./pages/SurveySetup";
import Main from "./pages/Main";
import Layoutinner from "./components/Layoutinner";
import Layoutouter from "./components/Layoutouter";
import Home from "./pages/Home";
import Surveypreview from "./pages/Surveypreview";

function App() {
  const { user, setUser } = useUser();
  //const isSurveyUser = new URLSearchParams(window.location.search).get("su");

  if (!user) {
    return <Login setUser={setUser} />;
  }

  return (
    <>
      <Routes>
        {/*<Route exact path="/" Component={Layoutouter}>
          <Route path="/" Component={Home}></Route>
        </Route>*/}
        <Route exact path="/" Component={Layoutinner}>
          <Route exact path="/" Component={Main}></Route>
          <Route exact path="/useradd" Component={Useradd}></Route>
          <Route exact path="/usersearch" Component={Usersearch}></Route>
          <Route exact path="/surveysearch" Component={Surveysearch}></Route>
          <Route exact path="/surveyadd" Component={Surveyadd}></Route>
          <Route exact path="/surveysetup" Component={SurveySetup}></Route>
          <Route exact path="/surveyanalyze" Component={SurveyAnalyze}></Route>
          <Route exact path="/test" Component={Test}></Route>
          <Route exact path="/surveypreview" Component={Surveypreview}></Route>
        </Route>
      </Routes>
    </>
  );
}
export default App;
